module.exports = __webpack_public_path__ + "@/assets/img/01.3d6dd649.svg";